module.exports = __webpack_public_path__ + "static/media/17.M-Cure 8-c.62383ef2.jpg";